import Vue from "vue";
import Vuex from "vuex";
import VueResource from "vue-resource";
import axios from "axios";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import VueMask from "v-mask";
import VueGoogleCharts from "vue-google-charts/legacy";

import App from "./App.vue";
import Snotify, { SnotifyPosition } from "vue-snotify";

import "jquery/dist/jquery.js";
import "popper.js/dist/popper.js";
import "bootstrap/dist/js/bootstrap.js";
import "select2/dist/js/select2.min.js";

import datePicker from "vue-bootstrap-datetimepicker";
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

import Trap from "vue-focus-lock";
import { Chrome } from "vue-color";

import VueOffline from "vue-offline";

import GlobalFunctions from "./global/global-functions.js";
import { store } from "./shared/store.js";
import mdMessage from "./components/md-message";
import alert from "./components/alert";
import validation from "./components/validation";
import warnings from "./components/warnings";
import BarList from "./components/bar-list";
import BarFilter from "./components/bar-filter";
import BarGrid from "./components/bar-grid";
import BarManut from "./components/bar-manut";
import vLabel from "./components/label";
import labelTitle from "./components/label-title";
import vButton from "./components/button";
import formField from "./components/form-field";
import InputCep from "./components/input-cep";
import InputFone from "./components/input-fone";
import InputHora from "./components/input-hora";
import InputEmail from "./components/input-email";
import InputEmailList from "./components/input-email-list";
import InputValue from "./components/input-value";
import InputCheckbox from "./components/input-checkbox";
import InputSwitch from "./components/input-switch";
import InputMonth from "./components/input-month";
import InputMonth2 from "./components/input-month2";
import InputNumber from "./components/input-number";
import InputPart from "./components/input-part";
import InputItem from "./components/input-item";
import InputSearch from "./components/input-search";
import InputDate from "./components/input-date";
import InputColorPicker from "./components/input-color-picker";
import tabs from "./components/tabs";
import select2 from "./components/select2";
import select2static from "./components/select2static";
import InputTypeahead from "./components/input-typeahead";
import emailForm from "./components/email-form";
import fonesPartShare from "./components/fones-part-share";
import confirmAdminPass from "./components/confirm-adminpass";
//import notificationOnOffline from './components/notification-online-offline'

import RecuperarForm from "./forms/app-recuperar-form";
import RegistroForm from "./forms/app-registro-form";
import AtivacaoForm from "./forms/app-ativacao-form";
import SenhaForm from "./forms/app-senha-usuario-form";
import AssinaturaForm from "./forms/app-assinatura-form";
import MinhaContaForm from "./forms/app-minha-conta-form";
import PlanosNfe from "./forms/app-planos-nfe";
import PlanosErp from "./forms/app-planos-erp";
import IncrementAddons from "./forms/app-plano-increment-addons";
import LoginForm from "./forms/app-login-form";
import DashboardForm from "./dashboards/dashboard-form";
import AppCertificado from "./forms/app-certificado";

import ConsultaVendas from "./consultas/consulta-vendas";
import ConsultaCurvaCliente from "./consultas/consulta-curva-cliente";
import ConsultaCarteiraClientes from "./consultas/consulta-carteira-clientes";
import ConsultaVendasPorProduto from "./consultas/consulta-vendas-por-produto";
import ConsultaVendasPerformanceCarteira from "./consultas/consulta-vendas-performance-carteira";
import ConsultaVendasPorCliente from "./consultas/consulta-vendas-por-cliente";
import ConsultaVendasVendedor from "./consultas/consulta-vendas-vendedor";
import ConsultaPedidosProduto from "./consultas/consulta-vendas-pedidos-produto";
import ConsultaListaClientes from "./consultas/listagem-clientes";
import ConsultaPedidosFaturados from "./consultas/consulta-vendas-pedidos-faturados";
import ConsultaPedidosComissao from "./consultas/consulta-vendas-comissao-por-pedido";
import ConsultaVarejoMovimentoCaixa from "./consultas/consulta-varejo-movimento-caixa";
import ConsultaVarejoPendcli from "./consultas/consulta-varejo-pendcli";
import MetaVendasForm from "./forms/metavendas-form";
import ConsultaRecebimentosPedido from "./consultas/consulta-recebimentos-pedido";

import ConsultaEstoqueProduto from "./consultas/consulta-estoque-produto";
import ConsultaItemsEstoque from "./consultas/consulta-items-estoque";

import ConsultaNfse from "./consultas/consulta-nfse";
import ConsultaDistribuicaoCfop from "./consultas/consulta-distribuicao-cfop";

import CustomerImportaForm from "./forms/customer-importa-form";
import PartList from "./forms/customer-list";
import PartForm from "./forms/customer-form";
import ItemList from "./forms/item-list";
import ItemForm from "./forms/item-form";
import ItemImportaForm from "./forms/item-importa-form";
import ItemImportaEstoqueForm from "./forms/item-importa-estoque-form";
import NatesList from "./forms/nates-list";
import EstadoList from "./forms/estado-list";
import IvaclassList from "./forms/ivaclass-list";
import IvancmList from "./forms/ivancm-list";
import UnimedList from "./forms/unimed-list";
import NcmList from "./forms/ncm-list";
import GradeList from "./forms/grade-list";
import GruestList from "./forms/gruest-list";
import GrucliList from "./forms/grucli-list";
import GruforList from "./forms/grufor-list";
import DepoList from "./forms/depo-list";
import MennfList from "./forms/mennf-list";
import VendList from "./forms/vend-list";
import FilialList from "./forms/filial-list";
import FilialForm from "./forms/filial-form";
import ConfigGuia from "./forms/config-guia.vue";
import PedidoList from "./forms/pedido-list";
import PedidoForm from "./forms/pedido-form";
import CompraList from "./forms/compra-list";
import CompraForm from "./forms/compra-form";
import RegrafcpList from "./forms/regrafcp-list";
import RegrastList from "./forms/regrast-list";
import RegraimpList from "./forms/regraimp-list";
import UsuarioList from "./forms/usuario-list";
import NfList from "./forms/nf-list";
import nfsaidaForm from "./forms/nfsaida-form";
import nfentradaForm from "./forms/nfentrada-form";
import SerienfList from "./forms/serienf-list";
import ContadorList from "./forms/contador-list";
import RamoatList from "./forms/ramoat-list";
import NatfinList from "./forms/natfin-list";
import InutList from "./forms/inut-list";
import ImportaIbpt from "./forms/importa-ibpt";
import ImportaXml from "./forms/importa-xml";
import ImportaXMLHist from "./forms/importa-xmlhist";
import nfimportList from "./forms/nfimport-list";
import duimpList from "./forms/duimp-list";
import duimpForm from "./forms/duimp-form";
import ReceberList from "./forms/receber-list";
import FinanceiroList from "./forms/financeiro-list";
import ConciliacaoForm from "./forms/conciliacao-form";
import PedidoImpressao from "./forms/pedido-impressao";
import PedidoCompraImpressao from "./forms/pedido-compra-impressao";
import FinanceirologList from "./forms/financeirolog-list";
import CtaList from "./forms/cta-list";
import FpagList from "./forms/fpag-list";
import VCaixaList from "./forms/vcaixa-list";
import PrintForm from "./forms/print-form";
import TabpreList from "./forms/tabpre-list";
import DestaqList from "./forms/destaq-list";
import TabdesList from "./forms/tabdes-list";
import ConfigMenu from "./forms/config-menu";
import nfseForm from "./forms/nfse-form";
import CobBanking from './forms/cobranca.vue'
import CobrancaConfig from './forms/cobranca-config.vue'

//APP FORCA VENDAS
import AgendaList from "./forms/agenda-list";
import FvClienteList from "./forms-fv/fv-cliente-list";
import ClientePainelForm from "./forms/customer-painel-form";
import FvPedidoList from "./forms-fv/fv-pedido-list";
import FvPedidoForm from "./forms-fv/fv-pedido-form";
// import FvClientesMenu from './forms-fv/fv-clientes-menu'
import FvProdutosMenu from "./forms-fv/fv-produtos-menu";
import FvConfigMenu from "./forms-fv/fv-config-menu";
import FvPedidoPagForm from "./forms-fv/fv-pedido-form-pag";

//LOJA
import ConfigListLoja from "./forms-loja/config-list-loja";
import GuiaLoja from "./forms-loja/guia-loja";

//CRM
import CrmPainelForm from "./forms-crm/crm-painel-form";
import CrmNegocioForm from "./forms-crm/crm-negocio-form";
import CrmLeadList from "./forms-crm/crm-lead-list";
import CrmPessoaList from "./forms-crm/crm-pessoa-list";
import CrmPessoaForm from "./forms-crm/crm-pessoa-form";
import CrmOrgForm from "./forms-crm/crm-org-form";
import CrmOrgList from "./forms-crm/crm-org-list";
import CrmEmailList from "./forms-crm/crm-email-list";
import CrmConfig from "./forms-crm/crm-config";
// import CrmOrganizacaoForm from './forms-crm/crm-organizacao-form'
// import CrmOrganizacaoList from './forms-crm/crm-organizacao-list'

import MercadolivreCode from "./forms/app-mercadolivre-code";
import CatmktList from "./forms/catmkt-list";
import CatmktForm from "./forms/catmkt-form";
import ManifestoList from "./forms/manifesto-list";

//ESTOQUE
import EstoqueAjusteTransferenciaForm from "./forms-estoque/estoque-ajuste-transferencia-form";
import ItemAjusteEstoque from "./forms/item-ajuste-estoque";
import ItemPrecosList from "./forms/item-precos-list";
import ConsultaMovimentoEstoque from "./consultas/consulta-movimento-estoque";
import ConsultaResumoMovimentoEstoque from "./consultas/consulta-resumo-movimento-estoque";
import ConsultaSaldoEstoque from "./consultas/consulta-saldo-estoque";
import ItemEntradasSaidas from "./forms/item-entradas-saidas";

//VAREJO
import VarejoList from "./forms-varejo/varejo-list";
import VarejoForm from "./forms-varejo/varejo-form";
import VarejoControlecaixaList from "./forms-varejo/varejo-controlecaixa-list";
import VarejoRecebiveisList from "./forms-varejo/varejo-recebiveis-list";
import VarejoDevolucaoList from "./forms-varejo/varejo-devolucao-list";

//FINANCEIRO
import ConsultaFluxoCaixa from "./forms-consultas/consulta-fluxo-caixa";
import ConsultaDre from "./forms-consultas/consulta-dre";
import ConsultaPosicaoFinanceiro from "./consultas/consulta-posicao-financeiro";
import ConsultaFinanceiroBaixas from "./consultas/consulta-financeiro-baixas";
import ContadorEmpresas from "./forms/contador-empresas";

window.jQuery = require("jquery"); // << import jquery global
require("bootstrap"); // << import js bootstrap

//Vue.use(VueResource)
Vue.use(VueAxios, axios);

Vue.use(datePicker);

//BLOQUEIO DO FOCUS EM FORM MODAL
Vue.use(Trap);

Vue.use(Chrome);
Vue.use(VueMask);

Vue.use(VueOffline, { storage: true, mixin: false });

// Charts Google
Vue.use(VueGoogleCharts);

//EXCEL
// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)

//EDITOR
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {});
require("vue-wysiwyg/dist/vueWysiwyg.css");

//TOAST NOTIFY
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    timeout: 5000,
    showProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    oneAtTime: true,
    preventDuplicates: true
  }
};
Vue.use(Snotify, options);
import "vue-snotify/styles/material.css";
// import 'vue-snotify/styles/simple.css'
//import 'vue-snotify/styles/dark.css'

//CSS
import "bootstrap/dist/css/bootstrap.css";
import "select2/dist/css/select2.min.css";
//https://github.com/select2/select2-bootstrap-theme
import "./css/select2-bootstrap.min.css";

//LIBS
//import '../node_modules/bootstrap/dist/css/bootstrap.css';
//import '../node_modules/select2/dist/css/select2.min.css';

//require('bootstrap'); // << import js bootstrap
//import 'bootstrap/dist/css/bootstrap.css' // << import CSS
//require('!style-loader!css-loader!font-awesome/css/font-awesome.css');

//VALIDATOR
import VeeValidate from "vee-validate";
import CpfValidator from "./validators/cpf-validator";
import CnpjValidator from "./validators/cnpj-validator";
import ZeroValidator from "./validators/zero-validator";
import Dictionary from "./shared/dictionaryPT";

//FILTERS
import {
  getText,
  formatDate,
  formatValue,
  formatFone,
  formatDataExtenso,
  formatDataHoraExtenso,
  formatDataHora,
  formatMesExtenso,
  formatCNPJCPF
} from "./shared/utils";

Vue.filter("formatValue", function(value, decimals, zeros) {
  if (!value)
    if (zeros) return formatValue(0, decimals);
    else return "--";
  else return formatValue(value, decimals);
});

Vue.filter("formatData", function(value) {
  return formatDate(value);
});

Vue.filter("formatDataHora", function(value) {
  return formatDataHora(value);
});

Vue.filter("formatFone", function(value) {
  return formatFone(value);
});

Vue.filter("getTextOption", function(value, options) {
  return getText(value, options);
});

Vue.filter("formatCNPJCPF", function(value) {
  return formatCNPJCPF(value);
});

Vue.filter("formatDataExtenso", function(value) {
  return formatDataExtenso(value);
});

Vue.filter("formatMesExtenso", function(value) {
  return formatMesExtenso(value);
});

Vue.filter("formatDataHoraExtenso", function(value) {
  return formatDataHoraExtenso(value);
});

//ROUTER
Vue.use(VueRouter);
const routes = [
  //rotas publicas
  {
    path: "/imprimir-pedido",
    component: PedidoImpressao,
    name: "imprimir-pedido"
  },
  {
    path: "/imprimir-compra",
    component: PedidoCompraImpressao,
    name: "imprimir-compra"
  },
  { path: "/planos/nfe", component: PlanosNfe, name: "planosnfe" },
  { path: "/planos/erp", component: PlanosErp, name: "planoserp" },
  {
    path: "/planos/complementos",
    component: IncrementAddons,
    name: "planosincremento"
  },
  { path: "/recuperar", component: RecuperarForm, name: "recuperar" },
  // { path: '/registro', component: RegistroForm, name: 'registro' },
  {
    path: "/registropedidos",
    component: RegistroForm,
    name: "registropedidos"
  },
  { path: "/registroloja", component: RegistroForm, name: "registroloja" },
  { path: "/registronfe", component: RegistroForm, name: "registronfe" },
  { path: "/ativar", component: AtivacaoForm, name: "ativar" },
  { path: "/senha", component: SenhaForm, name: "senha" },
  { path: "/login", component: LoginForm, name: "login" },

  { path: "/assinar", component: AssinaturaForm, name: "assinar" },

  { path: "/minhaconta", component: MinhaContaForm, name: "minhaconta" },
  { path: "/cadastro", component: AssinaturaForm, name: "cadastro" },

  //rotas privadas

  { path: '/contador/empresas', component: ContadorEmpresas, name: 'contador_empresas' },
  { path: '/', component: DashboardForm, name: 'home' },
  { path: '/guiapedidos', component: DashboardForm, name: 'guiapedidos' },
  { path: '/painelpedidos', component: DashboardForm, name: 'painelpedidos' },
  { path: '/guianfe', component: DashboardForm, name: 'guianfe' },
  { path: '/painelnfe', component: DashboardForm, name: 'painelnfe' },
  { path: '/painelservico', component: DashboardForm, name: 'painelservico' },
  { path: '/painelvarejo', component: DashboardForm, name: 'painelvarejo' },

  { path: '/app-certificado', redirect: '/filiallist/certificado' },
  { path: '/certificado', redirect: '/filiallist/certificado' },
  { path: '/certificado/:param', component: AppCertificado, name: 'certificado' },

  { path: '/vendlist', component: VendList, name: 'vendlist' },
  { path: '/part/:id', component: PartForm, name: 'part' },
  { path: '/partlist', component: PartList, name: 'partlist' },
  { path: '/mennflist', component: MennfList, name: 'mennflist' },
  { path: '/gruclilist', component: GrucliList, name: 'gruclilist' },
  { path: '/gruforlist', component: GruforList, name: 'gruforlist' },
  { path: '/ramoatlist', component: RamoatList, name: 'ramoatlist' },
  { path: '/natfinlist', component: NatfinList, name: 'natfinlist' },

  { path: '/importa/produtos', component: ItemImportaForm, name: 'importaprodutos' },
  { path: '/importa/clientes', component: CustomerImportaForm, name: 'importaclientes' },
  { path: '/importa/estoque', component: ItemImportaEstoqueForm, name: 'importaestoqueprodutos' },
  { path: '/estoque/saldo', component: ItemAjusteEstoque, name: 'estoqueajuste' },
  { path: '/estoque/saldoentradasaida', component: ItemEntradasSaidas, name: 'estoquesaldo' },

  { path: '/itemlist', component: ItemList, name: 'itemlist' },
  { path: '/item/:id', component: ItemForm, name: 'item' },
  { path: '/gradelist', component: GradeList, name: 'gradelist' },
  { path: '/gruestlist', component: GruestList, name: 'gruestlist' },
  { path: '/depolist', component: DepoList, name: 'depolist' },
  { path: '/destaqlist', component: DestaqList, name: 'destaqlist' },
  { path: '/tabdeslist', component: TabdesList, name: 'tabdeslist' },

  { path: '/configuracoes', component: ConfigMenu, name: 'configmenu' },
  { path: '/empresa', component: FilialForm, name: 'empresa' },
  { path: '/guiaempresa', component: ConfigGuia, name: 'guiaempresa' },
  { path: '/guiaempresa/:param', component: ConfigGuia, name: 'guiaempresa' },
  { path: '/filiallist', component: FilialList, name: 'filiallist' },
  { path: '/filiallist/:operacao', component: FilialList, name: 'filiallist' },
  { path: '/estadolist', component: EstadoList, name: 'estadolist' },
  { path: '/ivaclasslist', component: IvaclassList, name: 'ivaclasslist' },
  { path: '/ivancmlist', component: IvancmList, name: 'ivancmlist' },
  { path: '/contadorlist', component: ContadorList, name: 'contadorlist' },
  { path: '/usuariolist', component: UsuarioList, name: 'usuariolist' },
  { path: '/unimedlist', component: UnimedList, name: 'unimedlist' },
  { path: '/ncmlist', component: NcmList, name: 'ncmlist' },
  { path: '/nateslist', component: NatesList, name: 'nateslist' },
  { path: '/serienflist', component: SerienfList, name: 'serienflist' },
  { path: '/importaxml', component: ImportaXml, name: 'importaxml' },
  { path: '/importaibpt', component: ImportaIbpt, name: 'importaibpt' },
  { path: '/importaxmlhist', component: ImportaXMLHist, name: 'importaxmlhist' },
  { path: '/nfimportlist', component: nfimportList, name: 'nfimportlist' },
  { path: '/duimplist', component: duimpList, name: 'duimplist' },

  { path: '/regraimplist', component: RegraimpList, name: 'regraimplist' },
  { path: '/regrastlist', component: RegrastList, name: 'regrastlist' },
  { path: '/regrafcplist', component: RegrafcpList, name: 'regrafcplist' },

  { path: '/nflist/:operacao', component: NfList, name: 'nflist' },
  { path: '/inutlist', component: InutList, name: 'inutlist' },
  { path: '/nf/:id', component: nfsaidaForm, name: 'nfsaida' },
  { path: '/nfentrada/:id', component: nfentradaForm, name: 'nfentrada' },
  { path: '/pedidolist', component: PedidoList, name: 'pedidolist' },
  { path: '/pedido/:novo', component: PedidoForm, name: 'pedido' },
  { path: '/compralist', component: CompraList, name: 'compralist' },
  { path: '/compra/:novo', component: CompraForm, name: 'compra' },
  { path: '/varejo', component: VarejoForm, name: 'varejoform' },
  { path: '/varejolist', component: VarejoList, name: 'varejolist' },
  { path: '/varejolist/:tipo', component: VarejoList, name: 'varejolist' },
  { path: '/printform', component: PrintForm, name: 'PrintForm' },
  { path: '/tabpre', component: TabpreList, name: 'tabprelist' },
  { path: '/nfse/:id', component: nfseForm, name: 'nfseform' },

  { path: '/cta', component: CtaList, name: 'ctalist' },
  { path: '/fpag', component: FpagList, name: 'fpaglist' },
  { path: '/caixas', component: VCaixaList, name: 'vcaixalist' },
  { path: '/financeiro', component: FinanceiroList, name: 'financeirolist' },
  { path: '/conciliacao', component: ConciliacaoForm, name: 'conciliacao-form' },
  // { path: '/financeirolog', component: FinanceirologList, name: 'financeirologlist' },
  { path: '/cnab', component: ReceberList, name: 'receberlist' },
  { path: '/banking', component: CobBanking, name: 'cobbanking'},
  { path: '/cobranca-config', component: CobrancaConfig, name: 'cobrancaconfig'},

  { path: "/catmkt", component: CatmktList, name: "catmktlist" },

  { path: "/manifesto", component: ManifestoList, name: "manifestolist" },

  // APP FORCA DE VENDAS
  { path: "/fv/clientes", component: FvClienteList, name: "fvclientelist" },
  {
    path: "/fv/clientes/painel/:id",
    component: ClientePainelForm,
    name: "clientepainel"
  },
  { path: "/fv/pedidos", component: FvPedidoList, name: "fvpedidolist" },
  {
    path: "/fv/pedidos/:id/:codpart",
    component: FvPedidoForm,
    name: "fvpedidoform"
  },
  { path: "/fv/agenda", component: AgendaList, name: "fvagendalist" },
  { path: "/fv/produtos", component: FvProdutosMenu, name: "fvprodutosmenu" },
  { path: "/configuracoes", component: FvConfigMenu, name: "fvconfigmenu" },
  //{ path: '/fv/clientes', component: FvClientesMenu, name: 'fvclientesmenu' },
  {
    path: "/fv/pedidocheckout/:id/:idempresa",
    component: FvPedidoPagForm,
    name: "fvpedidopagform"
  },

  // LOJA
  { path: "/loja", component: ConfigListLoja, name: "loja" },
  { path: "/guialoja", component: GuiaLoja, name: "guialoja" },

  // CRM
  { path: "/crm/painel", component: CrmPainelForm, name: "crmpainelform" },
  { path: "/crm/lead/list", component: CrmLeadList, name: "crmleadlist" },
  { path: "/crm/pessoa/list", component: CrmPessoaList, name: "crmpessoalist" },
  { path: "/crm/pessoa/:id", component: CrmPessoaForm, name: "crmpessoaform" },
  {
    path: "/crm/negocio/:codnegocio",
    component: CrmNegocioForm,
    name: "crmnegocioform"
  },
  {
    path: "/crm/negocio/:codnegocio/orcamento/:id",
    component: FvPedidoForm,
    name: "fvpedidoform"
  },
  { path: "/crm/organizacao/list", component: CrmOrgList, name: "crmorglist" },
  { path: "/crm/organizacao/:id", component: CrmOrgForm, name: "crmorgform" },
  { path: "/crm/email/list", component: CrmEmailList, name: "crmemaillist" },
  { path: "/crm/config", component: CrmConfig, name: "crmconfig" },
  // { path: '/crm/organizacao/list', component: CrmOrganizacaoList, name: 'crmorganizacaolist' },
  // { path: '/crm/organizacao/:id', component: CrmOrganizacaoForm, name: 'crmorganizacaoform' },

  //mercado livre
  {
    path: "/mercadolivre/code",
    component: MercadolivreCode,
    name: "mercadolivreCode"
  },

  //somente aplicativo pedidos
  {
    path: "/estoque/saldo",
    component: ItemAjusteEstoque,
    name: "estoqueajuste"
  },

  //somente aplicativo NFE
  {
    path: "/estoque/saldoentradasaida",
    component: ItemPrecosList,
    name: "estoquesaldo"
  },

  //estoque
  {
    path: "/estoque/ajuste/novo/:item",
    component: EstoqueAjusteTransferenciaForm,
    name: "estoqueajusteform"
  },
  {
    path: "/consultas/entrada-e-saida",
    component: ConsultaMovimentoEstoque,
    name: "movimentoestoque"
  },
  {
    path: "/consultas/resumo-entrada-e-saida",
    component: ConsultaResumoMovimentoEstoque,
    name: "resumomovimentoestoque"
  },
  {
    path: "/consultas/estoque-saldo",
    component: ConsultaSaldoEstoque,
    name: "saldoestoque"
  },
  //consultas estoque
  {
    path: "/consultas/estoque-produto",
    component: ConsultaEstoqueProduto,
    name: "consultaestoqueproduto"
  },
  {
    path: "/consultas/items-estoque",
    component: ConsultaItemsEstoque,
    name: "consultaitemsestoque"
  },

  //consultas vendas
  {
    path: "/consultas/vendas",
    component: ConsultaVendas,
    name: "consultavendas"
  },
  {
    path: "/consultas/curvacliente",
    component: ConsultaCurvaCliente,
    name: "consultacurvacliente"
  },
  {
    path: "/consultas/carteiraclientes",
    component: ConsultaCarteiraClientes,
    name: "consultacarteiraclientes"
  },
  {
    path: "/consultas/vendas-produtos",
    component: ConsultaVendasPorProduto,
    name: "consultavendasprodutos"
  },
  {
    path: "/consultas/vendas-performance-carteira",
    component: ConsultaVendasPerformanceCarteira,
    name: "consultavendasperformance"
  },
  {
    path: "/consultas/vendas-por-cliente",
    component: ConsultaVendasPorCliente,
    name: "consultavendasclientes"
  },
  {
    path: "/consultas/vendas-vendedor",
    component: ConsultaVendasVendedor,
    name: "consultavendasvendedor"
  },
  {
    path: "/consultas/vendas-pedidos-produto",
    component: ConsultaPedidosProduto,
    name: "consultapedidosproduto"
  },
  {
    path: "/consultas/lista-clientes",
    component: ConsultaListaClientes,
    name: "consultalistaclientes"
  },
  { path: "/metas", component: MetaVendasForm, name: "metavendasform" },
  {
    path: "/consultas/vendas-pedidos-faturados",
    component: ConsultaPedidosFaturados,
    name: "consultapedidosfaturados"
  },
  {
    path: "/consultas/vendas-pedidos-comissao-por-pedido",
    component: ConsultaPedidosComissao,
    name: "consultapedidoscomissao"
  },
  {
    path: "/consultas/varejo-movimento-caixa",
    component: ConsultaVarejoMovimentoCaixa,
    name: "ConsultaVarejoMovimentoCaixa"
  },
  {
    path: "/consultas/vendas-pedido-recebimentos",
    component: ConsultaRecebimentosPedido,
    name: "consultarecebimentospedido"
  },
  {
    path: "/consultas/varejo-pendencia-cliente",
    component: ConsultaVarejoPendcli,
    name: "consultavarejopendenciacliente"
  },


  { path: "/consultas/nfse", component: ConsultaNfse, name: "consultanfse" },
  { path: "/consultas/distribuicaocfop", component: ConsultaDistribuicaoCfop, name: "consultadistribuicaocfop" },
  { path: "/consultas/faturamento-cfop", component: ConsultaDistribuicaoCfop, name: "consultafaturamentocfop" },

  //varejo
  {
    path: "/varejo/controlecaixa",
    component: VarejoControlecaixaList,
    name: "controlecaixa"
  },
  {
    path: "/varejo/controlecaixa/:id",
    component: VarejoControlecaixaList,
    name: "controlecaixa"
  },
  {
    path: "/varejo/recebiveis",
    component: VarejoRecebiveisList,
    name: "VarejoRecebiveisList"
  },
  {
    path: "/varejo/devolucaolist",
    component: VarejoDevolucaoList,
    name: "VarejoDevolucaoList"
  },
  { path: "/varejo/:novo", component: VarejoForm, name: "varejoform" },

  //financeiro
  {
    path: "/financeiro/fluxodecaixa",
    component: ConsultaFluxoCaixa,
    name: "ConsultaFluxoCaixa"
  },
  { path: "/financeiro/dre", component: ConsultaDre, name: "ConsultaDre" },
  {
    path: "/financeiro/posicaofinanceiro",
    component: ConsultaPosicaoFinanceiro,
    name: "ConsultaPosicaoFinanceiro"
  },
  {
    path: "/financeiro/financeirobaixas",
    component: ConsultaFinanceiroBaixas,
    name: "ConsultaFinanceiroBaixas"
  }
];

export const SysVars = new Vue({
  //https://forum.vuejs.org/t/how-set-global-state-available-to-all-components/5947/2
  data: {
    crudI: "ins",
    crudU: "upd",
    crudD: "del",
    crudC: "can",
    crudInsert: "ins",
    crudUpdate: "upd",
    crudDelete: "del",
    crudCancel: "can",
    crudView: "view",
    // appPlanoContratado: '',
    appCrm: false,
    appForcaVendas: false,
    appLoja: false,
    appNFe: false,
    appVarejo: false,
    appERP: false,
    ambienteHomologacaoNFe: false,
    usuarioComum: false,
    usuarioAdministrador: false,
    usuarioForcaVendas: false, //tipo definido no cadastro de usuario
    usuarioVarejoPDV: false, //tipo definido no cadastro de usuario
    endereco: {},
    usaIntegracao: false,

    //CONTADOR DE EMAILS E AGENDA
    countEmail: null,
    countAgenda: null,

    //focus control - variavel utilizada para controle do enter nos formularios
    //sFocusControl: 'input:text, .select2-selection, select',
    //EXEMPLO QUERYSELECTOR: jQuery(this.$el).index('input:text:not([disabled],*[tabindex=-1]), .select2-selection:not([disabled],*[tabindex=-1]), select:not([disabled],*[tabindex=-1])')
    sFocusControl:
      "input:text:not([disabled]), input:password:not([disabled]), input:checkbox:not([disabled]), :radio:not([disabled]), .select2-selection:not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], area[href], button:not([disabled])",

    //quando usuario estiver logado
    appLogged: false,

    //quando expirou acesso trial
    appEndTrial: false,
    appTrial: false,
    appDataExpiracao: null,
    appAvisoRenovacao: null,
    appBlocked: false,
    urlBlocked: "",
    forceUrl: "",
    appFree: false,

    //loading
    appLoading: false,

    //controle modal para erros (this.$appError)
    appError: false,

    //controle para erros de conexao com servidor (this.$serverError)
    serverError: false,
    serverErrorStatus: "",
    serverErrorText: "",

    //controle de mensagens toast
    toastSuccess: "",
    toastError: "",
    toastWarning: "",

    //controle modal de mensagens e perguntas
    kindMessage: "", //danger, success, error, warning
    appCodeMessage: "",
    appMessage: "",
    appTitleMessage: "",
    appHelpeMessage: "",
    appShowMessage: false,

    //limite de plano
    limiteUsuariosAlcancado: false,
    limitePlanoMensagem: null,
    showLimitePlano: false,

    plano: null,

    guia: false,
    help: false,

    primeiroAcesso: true
  }
});

//VALIDATOR
VeeValidate.Validator.extend("cpf", CpfValidator);
VeeValidate.Validator.extend("cnpj", CnpjValidator);
VeeValidate.Validator.extend("valida-zero", ZeroValidator);
Vue.use(VeeValidate, { locale: "pt", dictionary: Dictionary });
// Vue.use(VeeValidate, { locale: 'pt', dictionary: Dictionary, events: 'blur' })
// Vue.use(VeeValidate, { locale: 'pt', dictionary: Dictionary, delay: 20 })
// VeeValidate.setMode('lazy')

//LIBS INTERNAS
Vue.use(GlobalFunctions);

//COMPONENTES
Vue.component("alert", alert);
Vue.component("validation", validation);
Vue.component("warnings", warnings);
Vue.component("md-message", mdMessage);
Vue.component("bar-manut", BarManut);
Vue.component("bar-list", BarList);
Vue.component("bar-grid", BarGrid);
Vue.component("v-label", vLabel);
Vue.component("label-title", labelTitle);
Vue.component("v-button", vButton);
Vue.component("form-field", formField);
Vue.component("input-cep", InputCep);
Vue.component("input-fone", InputFone);
Vue.component("input-hora", InputHora);
Vue.component("input-email", InputEmail);
Vue.component("input-email-list", InputEmailList);
Vue.component("input-value", InputValue);
Vue.component("input-checkbox", InputCheckbox);
Vue.component("input-switch", InputSwitch);
Vue.component("input-month", InputMonth);
Vue.component("input-month2", InputMonth2);
Vue.component("input-date", InputDate);
Vue.component("input-number", InputNumber);
Vue.component("input-part", InputPart);
Vue.component("input-item", InputItem);
Vue.component("input-search", InputSearch);
Vue.component("input-color-picker", InputColorPicker);
Vue.component("tabs", tabs);
Vue.component("select2", select2);
Vue.component("select2static", select2static);
Vue.component("input-typeahead", InputTypeahead);
Vue.component("email-form", emailForm);
Vue.component("fones-part-share", fonesPartShare);
Vue.component("confirm-adminpass", confirmAdminPass);
//Vue.component('notification-online-offline', notificationOnOffline)
//
//Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

let handleOutsideClick;

Vue.directive("closable", {
  bind(el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = e => {
      e.stopPropagation();
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value;

      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false;
      exclude.forEach(refName => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName];
          // See if this excluded element
          // is the same element the user just clicked on
          // console.log(refName)
          // console.log(excludedEl)
          if (excludedEl)
            if (excludedEl.length)
              clickedOnExcludedEl = excludedEl[0].contains(e.target);
            else clickedOnExcludedEl = excludedEl.contains(e.target);
        }
      });

      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]();
      }
    };
    // Register click/touchstart event listeners on the whole page
    document.addEventListener("click", handleOutsideClick);
    document.addEventListener("touchstart", handleOutsideClick);
  },

  unbind() {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener("click", handleOutsideClick);
    document.removeEventListener("touchstart", handleOutsideClick);
  }
});

const router = new VueRouter({
  //hashbang: false,
  //mode: 'history',
  base: "/app/",
  routes
});

new Vue({
  el: "#app",
  store,
  created() {
    //carrega o metadata do servidor backend
    this.$restRegisterInterceptor();
    // this.loadMetadata()
  },
  data: {
    //para acessar o dada: this.$root._data
    //this.$root.data_example()
  },
  methods: {
    //this.$root.method_example()
    // async loadMetadata () {
    // await this.$store.dispatch('loadMetadata')
    // }
  },
  render: h => h(App),
  router
});

router.beforeEach((to, from, next) => {
  if (
    to.name == "login" ||
    to.name == "assinar" ||
    to.name == "cadastro" ||
    to.name == "ativar" ||
    to.name == "senha" ||
    to.name == "registro" ||
    to.name == "registronfe" ||
    to.name == "registroloja" ||
    to.name == "registropedidos" ||
    to.name == "recuperar" ||
    to.name == "fvpedidopagform" ||
    to.name == "imprimir-pedido" ||
    to.name == "imprimir-compra"
  ) {
    next();
  } else if (SysVars.appLogged) {
    const isContador = store.getters.getEnv && store.getters.getEnv.tpempresa === 'E';
    if (isContador) {
      if (to.name !== 'contador_empresas') {
        next({ name: 'contador_empresas' });
      } else {
        next();
      }
    } else {
      if (
        to.name == "minhaconta" ||
        to.name == "planosnfe" ||
        to.name == "planoserp"
      ) {
        next();
      } else if (SysVars.forceUrl) {
        next({ path: SysVars.forceUrl });
      } else {
        next();
      }
    }
  } else {
    next({ name: "login" });
  }

  Tawk_API.showWidget();
});



// WEBPACK FOOTER //
// ./src/main.js